import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ExportToCsv } from 'export-to-csv';
import { DtpNoContent } from 'dtp-react-components';
import {
  Button,
} from '../../../components/index';
import {
  doPost,
} from '../../../utils/requests';
import ModalStatusIntegracaoGet from '../ModalStatusIntegracaoGet';
// import ModalStatusIntegracaoGet from '../ModalStatusIntegracaoGet';

class RelatorioOperacoesGet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNoContent: false,
      noContentPrimaryMessage: null,
      noContentSecondaryMessage: null,
      showStatusRetornoGetModal: false,
    };
  }

  tratarSucessoListaExportacao = (response) => {
    if (response.data !== '') {
      this.setState({
      }, this.gerarCsv(response.data));
    }
  };

  tratarErro = () => {
    const mensagemPrimaria = 'Não foi possível consultar a operações de envio ao GET.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  colunasExportacaoDefault = [
    'UO de Criação da Tarefa GET',
    'Protocolo Comprev',
    'Protocolo Tarefa GET',
    'Data de Inclusão',
    'Data de Envio',
    'Quantidade de Tentativas',
    'Status Operação',
    'Operação',
    'Origem',
    'Mensagem',
    'Retorno',
    'Observação',
    'Body',
  ];

  colunasExportacaoAlternativo = [
    'UO de Criação da Tarefa GET',
    'Protocolo Comprev',
    'Protocolo Tarefa GET',
    'Data de Inclusão',
    'Data de Envio',
    'Operação',
    'Status Operação',
    'Mensagem',
  ];
formatarProtocolo = (protocolo) => {
  let protocoloFormatado = '';
  if (protocolo) {
    protocoloFormatado = `'${protocolo}`;
    protocoloFormatado = `${protocoloFormatado}`;
  }
  return protocoloFormatado;
};
defineListaParaExportacao = (lista) => {
  const listaOriginal = lista;
  const resultado = [];
  if (this.props.papelUsuarioLogado === 'analista-dtp') {
    listaOriginal.forEach((envio) => {
      resultado.push({
        idUnidadeOrganica: envio.idUnidadeOrganica !== undefined ? envio.idUnidadeOrganica : '',
        idProtocolo: envio.idProtocolo ? this.formatarProtocolo(envio.idProtocolo) : '',
        idTarefaGet: envio.idTarefaGet !== undefined ? envio.idTarefaGet : '',
        dataInclusao: envio.dataInclusao !== undefined ? moment(envio.dataInclusao).format('DD/MM/YYYY HH:mm:ss') : '',
        dataEnvio: envio.dataEnvio !== undefined ? moment(envio.dataEnvio).format('DD/MM/YYYY HH:mm:ss') : '',
        quantidadeTentativas: envio.quantidadeTentativas !== undefined ? envio.quantidadeTentativas : '',
        status: envio.status !== undefined ? envio.status : '',
        operacao: envio.operacao !== undefined ? envio.operacao : '',
        origem: envio.origem !== undefined ? envio.origem : '',
        mensagem: envio.mensagem !== undefined ? envio.mensagem : '',
        retorno: envio.retorno !== undefined ? envio.retorno : '',
        observacao: envio.observacao !== undefined ? envio.observacao : '',
        body: envio.body !== undefined ? envio.body : '',
      });
    });
  } else {
    listaOriginal.forEach((envio) => {
      resultado.push({
        idUnidadeOrganica: envio.idUnidadeOrganica !== undefined ? envio.idUnidadeOrganica : '',
        idProtocolo: envio.idProtocolo ? this.formatarProtocolo(envio.idProtocolo) : '',
        idTarefaGet: envio.idTarefaGet !== undefined ? envio.idTarefaGet : '',
        dataInclusao: envio.dataInclusao !== undefined ? moment(envio.dataInclusao).format('DD/MM/YYYY HH:mm:ss') : '',
        dataEnvio: envio.dataEnvio !== undefined ? moment(envio.dataEnvio).format('DD/MM/YYYY HH:mm:ss') : '',
        operacao: envio.operacao !== undefined ? envio.operacao : '',
        status: envio.status !== undefined ? envio.status : '',
        mensagem: envio.mensagem !== undefined ? envio.mensagem : '',
      });
    });
  }
  return resultado;
};
exportar = () => {
  if (Object.entries(this.props.filtrosConsulta).length !== 0) {
    const nivel = this.props.defineNivelFiltro();
    const parametros = {
      'start-position': 0,
      'max-results': 100000,
    };
    if (this.props.filtrosConsulta.protocoloTarefaGet) {
      parametros.protocoloTarefaGet = this.props.converterValoresParaTipoNumerico(this.props.filtrosConsulta.protocoloTarefaGet);
    }
    if (this.props.filtrosConsulta.status) {
      parametros.status = this.props.converterValoresParaTipoNumerico(this.props.filtrosConsulta.status);
    }
    if (this.props.filtrosConsulta.protocoloComprev) {
      parametros.protocoloComprev = this.props.filtrosConsulta.protocoloComprev;
    }
    if (this.props.filtrosConsulta.cpf) {
      parametros.cpf = this.props.filtrosConsulta.cpf;
    }
    if (this.props.filtrosConsulta.mensagem) {
      parametros.mensagem = this.props.filtrosConsulta.mensagem;
    }
    if (nivel !== 0) {
      parametros.nivelUo = nivel;
    }
    if (nivel !== 0) {
      parametros.idUo = this.props.definirValorUo(nivel);
    }
    doPost(
      'operacoes-get/exportacoes',
      parametros,
      this.tratarSucessoListaExportacao,
      this.tratarErro,
    );
  }
};
handleModalStatusGetRetorno = () => {
  this.setState({
    showStatusRetornoGetModal: !this.state.showStatusRetornoGetModal,
  });
}
gerarCsv = (lista) => {
  let dadosRelatorio = null;
  const legenda = 'Registro de Operações do GET';
  if (lista && lista !== undefined && lista.length > 0) {
    dadosRelatorio = this.defineListaParaExportacao(lista);
  } else {
    dadosRelatorio = [];
  }

  if (dadosRelatorio && dadosRelatorio !== undefined && dadosRelatorio.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'RegistroOperacoesGET',
      fieldSeparator: ';',
      showTitle: true,
      title: legenda,
      showLabels: true,
      headers: this.props.papelUsuarioLogado === 'analista-dtp' ? this.colunasExportacaoDefault : this.colunasExportacaoAlternativo,
    });
    csvExporter.generateCsv(dadosRelatorio);
  }
}
render() {
  if (this.state.showNoContent) {
    return (
      <DtpNoContent
        primaryText={this.state.noContentPrimaryMessage}
        secondaryText={this.state.noContentSecondaryMessage}
        show={this.state.showNoContent}
      />);
  }
  return (
    <React.Fragment>
      <div className="row">
        <Button
          onClick={() => { this.exportar(); }}
          hint="Exporta Operações para arquivo CSV com filtro escolhido"
          icon="ico-doc-sheet"
          mini
        />
        <Button
          hint="Legenda para o Status da Operação"
          icon="ico-help-c"
          onClick={() => this.handleModalStatusGetRetorno('showStatusRetornoGetModal')}
          mini
        />
      </div>
      {this.state.showStatusRetornoGetModal ? (
        <ModalStatusIntegracaoGet
          {...this.props}
          estadoFormulario={this.state}
          handleModal={() => this.handleModalStatusGetRetorno('showStatusRetornoGetModal')}
          showModal={this.state.showStatusRetornoGetModal}
        />
            ) : ''}
    </React.Fragment>
  );
}
}

RelatorioOperacoesGet.propTypes = {
  voltarAction: PropTypes.func,
  filtrosConsulta: PropTypes.object,
  papelUsuarioLogado: PropTypes.string,
  converterValoresParaTipoNumerico: PropTypes.func,
  defineNivelFiltro: PropTypes.func,
  definirValorUo: PropTypes.func,
}.isRequired;

RelatorioOperacoesGet.defaultProps = {
  voltarAction: () => null,
};

export default RelatorioOperacoesGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/exportacao-csv/RelatorioOperacoesGet.jsx